import gql from "graphql-tag";

// fragment
export const USER_FRAGMENT = gql`
    fragment user on UserNode {
        id
        email
        firstName
        lastName
        hasCustomizedModules
        customizedModulesJson
        tenantUser {
            id
            isAdmin
            tenant {
                id
                name
                numberOfCustomizedModules
                customizedModulesJson
            }
        }
    }
`;

export const ME_QUERY = gql`
    query {
        me {
            id
            email
            firstName
            lastName
            hasCustomizedModules
            customizedModulesJson
            tenantUser {
                id
                isAdmin
                tenant {
                    id
                    name
                    numberOfCustomizedModules
                    customizedModulesJson
                }
            }
            permissions {
                id
                codename
            }
        }
    }
`;

export const LOGIN_MUTATION = gql`
    mutation TokenAuth($email: String!, $password: String!) {
        tokenAuth(email: $email, password: $password) {
            token
        }
    }
`;

export const TENANT_USERS_QUERY = gql`
    query TenantUsersQuery {
        tenantUsers {
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                cursor
                node {
                    ...user
                }
            }
        }
    }
    ${USER_FRAGMENT}
`;

// create
export const CREATE_USER_MUTATION = gql`
    mutation createUser($input: CreateUserInput!) {
        createUser(input: $input) {
            user {
                ...user
            }
        }
    }
    ${USER_FRAGMENT}
`;

// update
export const UPDATE_USER_MUTATION = gql`
    mutation updateUser($input: UpdateUserInput!) {
        updateUser(input: $input) {
            user {
                ...user
            }
        }
    }
    ${USER_FRAGMENT}
`;

// change password
export const CHANGE_PASSWORD_MUTATION = gql`
    mutation changePassword($input: ChangePasswordInput!) {
        changePassword(input: $input) {
            user {
                ...user
            }
        }
    }
    ${USER_FRAGMENT}
`;

// change my password
export const CHANGE_MY_PASSWORD_MUTATION = gql`
    mutation changeMyPassword($input: ChangeMyPasswordInput!) {
        changeMyPassword(input: $input) {
            user {
                ...user
            }
        }
    }
    ${USER_FRAGMENT}
`;

// delete
export const DELETE_USER_MUTATION = gql`
    mutation deleteUser($input: DeleteUserInput!) {
        deleteUser(input: $input) {
            user {
                ...user
            }
        }
    }
    ${USER_FRAGMENT}
`;
